<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :aria-labelledby="iconName"
    viewBox="0 0 24 24"
    role="presentation"
    class="icon"
  >
    <title :id="iconName">{{ iconName }} icon</title>
    <g :fill="iconColor">
      <path :d="iconPath" />
    </g>
  </svg>
</template>

<script>
import {
  mdiArchive,
  mdiGift,
  mdiViewDashboard,
  mdiPresentationPlay,
  mdiViewList,
  mdiChevronUp,
  mdiChevronDoubleRight,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCheckboxMarkedCircleOutline,
  mdiAccount,
  mdiArrowRight,
  mdiArrowLeft,
  mdiArrowUp,
  mdiArrowDown,
  mdiEmailOutline,
  mdiEmailSendOutline,
  mdiLockOutline,
  mdiCheck,
  mdiClose,
  mdiMenu,
  mdiMenuDown,
  mdiRepeat,
  mdiCalendarMonth,
  mdiEyeOff,
  mdiEye,
  mdiSwapVertical,
  mdiExportVariant,
  mdiPencil,
  mdiTrashCanOutline,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiPlusCircle,
  mdiMinusCircle,
  mdiMagnify,
  mdiMagnifyPlusOutline,
  mdiDotsVertical,
  mdiBell,
  mdiContentCopy,
  mdiTableOfContents,
  mdiMinus,
  mdiEqual,
  mdiInformation,
  mdiAccountArrowRight,
  mdiSend,
  mdiPlayCircle,
  mdiCash,
  mdiCashUsdOutline,
  mdiDownload,
  mdiYoutubeTv,
  mdiOpenInNew,
  mdiNoteSearchOutline,
  mdiFileOutline,
  mdiCalendarHeart,
  mdiAlertOutline,
} from '@/assets/icons';

const iconsPath = {
  dashboard: mdiViewDashboard,
  products: mdiArchive,
  orders: mdiViewList,
  pretraining: mdiPresentationPlay,
  rewards: mdiGift,
  'chevron-up': mdiChevronUp,
  'chevron-right': mdiChevronRight,
  'chevron-left': mdiChevronLeft,
  'chevron-double-right': mdiChevronDoubleRight,
  'arrow-right': mdiArrowRight,
  'arrow-left': mdiArrowLeft,
  'arrow-up': mdiArrowUp,
  'arrow-down': mdiArrowDown,
  'check-circle': mdiCheckboxMarkedCircleOutline,
  'menu-down': mdiMenuDown,
  menu: mdiMenu,
  close: mdiClose,
  check: mdiCheck,
  account: mdiAccount,
  email: mdiEmailOutline,
  'send-email': mdiEmailSendOutline,
  lock: mdiLockOutline,
  repeat: mdiRepeat,
  calendar: mdiCalendarMonth,
  eye: mdiEye,
  'eye-off': mdiEyeOff,
  'swap-vertical': mdiSwapVertical,
  export: mdiExportVariant,
  pencil: mdiPencil,
  trash: mdiTrashCanOutline,
  plus: mdiPlus,
  'plus-circle': mdiPlusCircle,
  minus: mdiMinus,
  'minus-circle': mdiMinusCircle,
  equal: mdiEqual,
  'plus-outline': mdiPlusCircleOutline,
  magnify: mdiMagnify,
  'magnify-plus': mdiMagnifyPlusOutline,
  'dots-vertical': mdiDotsVertical,
  bell: mdiBell,
  copy: mdiContentCopy,
  content: mdiTableOfContents,
  information: mdiInformation,
  'account-arrow-right': mdiAccountArrowRight,
  send: mdiSend,
  play: mdiPlayCircle,
  cash: mdiCash,
  'cash-usd': mdiCashUsdOutline,
  download: mdiDownload,
  watch: mdiYoutubeTv,
  openInNew: mdiOpenInNew,
  noteSearch: mdiNoteSearchOutline,
  file: mdiFileOutline,
  calendarHeart: mdiCalendarHeart,
  alert: mdiAlertOutline,
};

export default {
  name: 'VSvgIcon',
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    name: {
      type: String,
      default: 'products',
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
  computed: {
    iconPath() {
      return iconsPath[this.name];
    },
  },
};
</script>
